module.exports = __webpack_public_path__ + "static/media/template-icon-small.f005b6f7.svg";